module.exports = __webpack_public_path__ + "static/media/instagram-icon.d7ed2283.svg";